import Link from 'next/link';
import { useRouter } from 'next/router';
import Button from 'antd/lib/button/button';
import Dropdown from 'antd/lib/dropdown/dropdown';
import classNames from 'classnames';

import { ButtonText } from 'src/components/Button';
import ImageC from 'src/components/Image';
import useDeviceSize from 'src/utils/hooks/useDeviceSize';

import classes from './index.module.less';

interface Props {
	className?: string;
	data?: { name: string; path: string }[];
}

const TabMenu = ({ className, data }: Props) => {
	const deviceSize = useDeviceSize();

	const router = useRouter();

	return (
		<>
			{deviceSize !== 'mobile' ? (
				<div className={classNames(classes.nav, className)}>
					{data?.map(({ name, path }) => (
						<Link key={path} href={path} scroll={false}>
							<ButtonText
								className={classNames(classes.menu, {
									[classes.active]: path === router.pathname,
								})}
							>
								{name}
							</ButtonText>
						</Link>
					))}
				</div>
			) : (
				<Dropdown
					className={classNames(className)}
					overlayClassName={classes.dropdown}
					menu={{
						items: data?.map(({ name, path }) => ({
							key: path,
							label: (
								<div
									className={classNames(classes['menu-item'], {
										[classes.selected]: router.pathname === path,
									})}
									onClick={() => router.push(path, undefined, { scroll: false })}
								>
									{name}
								</div>
							),
						})),
					}}
					trigger={['click']}
					placement="bottomRight"
				>
					<Button className={classes['dropdown-control']}>
						{data?.find(({ path }) => path === router.pathname)?.name}
						<span className={classes['dropdown-control-arrow']}>
							<ImageC
								alt="icon caret down"
								src="/icons/icon_caret-down-fill.svg"
								height={12}
								width={12}
							/>
						</span>
					</Button>
				</Dropdown>
			)}
		</>
	);
};

export default TabMenu;
